import { tv } from 'tailwind-variants'

export const wingoSetupVariants = tv({
  slots: {
    container: 'flex h-screen bg-white',
    image: 'flex h-full w-[40%] items-center justify-center bg-pre-login-background bg-cover',
    form: 'flex h-full w-[60%] ml-[-20px] items-center rounded-l-deca z-12 bg-white shadow-[-25px_0px_20px_-20px_rgba(0,0,0,0.20)]',
    formContainer: 'flex flex-col ml-60 space-y-6',
    title: 'text-h1 font-bold mb-mili',
    subtitle: 'text-base text-medium',
    button:
      'bg-fb-button text-white border-none rounded-[4px] cursor-pointer text-deca font-bold h-[40px] w-[250px] hover:bg-fb-button-hover disabled:bg-fb-button-disabled disabled:cursor-default active:bg-fb-button'
  }
})
